import UnderConstruction from '@/components/ui/UnderConstruction';

const VisitHistory = () => {
  return (
    <UnderConstruction
      showFeatures={false}
      pageTitle="Historial de Visitas"
      customMessage="Esta función permitirá rastrear y analizar el historial de visitas de los usuarios, proporcionando insights valiosos sobre el comportamiento y preferencias de contenido."
    />
  );
}

export default VisitHistory;
